import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=44520a23&scoped=true&"
import script from "./FirstStep.vue?vue&type=script&lang=ts&"
export * from "./FirstStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44520a23",
  null
  
)

export default component.exports